'use client'

const TICKER_ITEMS = [
  'WEB DEVELOPMENT',
  'FULL STACK',
  'UI/UX DESIGN',
  'SEO',
  'VIDEOGRAPHY',
  'GRAPHIC DESIGN',
  '3D EXPERIENCES',
  'BRAND IDENTITY',
  'MOTION GRAPHICS',
]

export default function Ticker() {
  const text = TICKER_ITEMS.map(item => `${item} · `).join('')

  return (
    <div className="ticker-wrap overflow-hidden whitespace-nowrap py-3 border-t border-b border-white/10">
      <div className="ticker-inner">
        {/* Duplicate for seamless loop */}
        {[0, 1].map((i) => (
          <span
            key={i}
            className="inline-block pr-8 text-xs tracking-[0.25em] text-[#94A3B8]"
            style={{ fontFamily: 'var(--font-space-mono, "Space Mono", monospace)' }}
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  )
}
